import {useState} from 'react'
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { KTIcon, toAbsoluteUrl } from '../../../helpers';
import { HeaderUserMenu, ThemeModeSwitcher } from '../../../partials';
import { useLayout } from '../../core';
import { MenuItem } from './header-menus/MenuItem';
import { useSelector } from 'react-redux';

const itemClass = 'ms-1 ms-lg-3'
const userAvatarClass = 'symbol-30px symbol-md-40px'
const btnIconClass = 'fs-1'

const Navbar = () => {
  const { config } = useLayout()
  const intl = useIntl()
  const userData = localStorage.getItem('kt-auth-react-v');
  let user = null;

  const [dummyProfile,setDummyProfile] = useState("https://storage.freeicon.com/free-account-icon-WWEjLVcKFHSP");
  
  if (userData) {
    user = JSON.parse(userData);
  } else {
    console.error("User data not found in localStorage");
  }

  const userProfile = useSelector((state:any) => state.stores.userProfile)

  // const getTodayDate = () => {

  //   const monthArray = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  //   const date = new Date();
  //   const todayDate = date.getDate();
  //   return (
  //     <span>
  //       <span style={{ color: "#4168d1", marginLeft: "5px" }}>
  //         {monthArray[date.getMonth()]}&nbsp;
  //         {todayDate.toString().length > 1 ? todayDate : "0" + todayDate}
  //         <sup>{todayDate === 1 && "st"}{todayDate === 2 && "nd"}{todayDate === 3 && "rd"}{todayDate > 3 && "th"}</sup>&nbsp;
  //         {date.getFullYear()}
  //       </span>
  //     </span>
  //   );
  // };
  
  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <h3 className='text-gray-700' style={{ marginTop: "21px" }}>{getTodayDate()}</h3> */}
      {/* <div className="d-none d-lg-block">
        <MenuItem title={intl.formatMessage({ id: 'DASHBOARD' })} to='/dashboard' />
      </div> */}
      

      <div className={clsx('app-navbar-item', itemClass)}>
        
          <div
          className='cursor-pointer mt-2'
          data-kt-menu-trigger="{default: 'click'}"
          data-kt-menu-attach='parent'
          data-kt-menu-placement='bottom-end'
        >
          <div className="d-flex align-items-center mt-2">
          <div className={clsx('cursor-pointer symbol',userAvatarClass)}>
            <img src={userProfile || user?.avatar || dummyProfile} alt='' className='w-100' />
          </div>
           <div className='d-none d-md-block'>
            <h5 style={{lineHeight:0}} className='fs-5 text-gray-500 ms-3'>{user.first_name} {user.last_name}&nbsp;<i className="fas fa-chevron-down"></i></h5>
            <span className='badge badge-sm badge-warning text-dark ms-3'>{user.user_no}</span>
           </div>
        </div>
        </div>
        
       
        <HeaderUserMenu />
      </div>

      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}
    </div>
  )
}

export { Navbar }
